import { Component } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { CommonModule } from '@angular/common';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { HeaderComponent } from '../../header/header.component';
import { FooterComponent } from '../../footer/footer.component';

@Component({
  selector: 'app-appointment',
  templateUrl: './appointment.component.html',
  styleUrls: ['./appointment.component.scss'],
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, HeaderComponent, FooterComponent, MatSnackBarModule,],

})
export class AppointmentComponent {
  baseUrl = environment.baseUrl;

  isAppointmentSubmitted: boolean = false; // Used to show success message

  constructor(private http: HttpClient) {}

  appointmentForm = new FormGroup({
    name: new FormControl('', [Validators.required]),
    email: new FormControl('', [Validators.required, Validators.email]),
    phone: new FormControl('', [
      Validators.required,
      Validators.pattern('^[0-9]*$'),
    ]), // New Phone/WhatsApp field
    appointmentDate: new FormControl('', [Validators.required]), // New Requested Appointment Date field
  });

  onSubmit() {
    if (this.appointmentForm.valid) {
      const appointmentData = {
        full_name: this.appointmentForm.value.name,
        email: this.appointmentForm.value.email,
        phone: this.appointmentForm.value.phone,
        appointment_date: this.appointmentForm.value.appointmentDate,
        loan_type_id: 2, // Setting loan_type_id as 2 (you can adjust this based on your needs)
        organization_id: 1, // Setting organization_id as 1
        enq_detail_msg: '', // Optional, you can modify this if required
      };

      this.http
        .post(`${this.baseUrl}/add_basic_enquiry`, appointmentData)
        .subscribe({
          next: (res: any) => {
            console.log('Response from API:', res);
            if (res.success) {
              console.log('Appointment submission successful!');
              this.appointmentForm.reset(); // Reset the form after successful submission
              this.isAppointmentSubmitted = true; // Show success message

              // Automatically hide the success message after 5 seconds
              setTimeout(() => {
                this.isAppointmentSubmitted = false;
              }, 5000);
            } else {
              console.log('Submission failed:', res);
            }
          },
          error: (err: any) => {
            console.log('Error during submission:', err);
          },
        });
    } else {
      console.error('Form is invalid');
    }
  }
}
